module.exports = __webpack_public_path__ + "img/web_banner.5e501f7e.png";